// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-email-page {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.verify-email-page .verify-email-container {
  width: 450px;
  text-align: center;
  padding: 40px;
  border-radius: 10px;
}
.verify-email-page .verify-email-container h2 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #333;
}
.verify-email-page .verify-email-container .subtext {
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
}
.verify-email-page .verify-email-container .verify-email-form .code-inputs {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.verify-email-page .verify-email-container .verify-email-form .code-inputs input {
  width: 40px;
  height: 40px;
  font-size: 18px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 60px;
  background-color: #f9f9f9;
}
.verify-email-page .verify-email-container .verify-email-form .resend-button {
  width: 40%;
  padding: 10px;
  background-color: #f4eaf4;
  color: #8e2d8e;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-bottom: 20px;
}
.verify-email-page .verify-email-container .verify-email-form .resend-button:hover {
  background-color: #7b2a7b;
}
.verify-email-page .verify-email-container .verify-email-form .resend-button:active {
  background-color: #7b2a7b; /* Darker shade for active state */
}
.verify-email-page .verify-email-container .verify-email-form .resend-button:disabled {
  background-color: #e0e0e0; /* Disabled color */
  cursor: not-allowed;
}
.verify-email-page .verify-email-container .verify-email-form .continue-button {
  width: 100%;
  padding: 12px;
  background-color: #8e2d8e;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.verify-email-page .verify-email-container .verify-email-form .continue-button:hover {
  background-color: #c0c4c9;
}
.verify-email-page .verify-email-container .terms-text {
  font-size: 12px;
  color: #666;
  margin-top: 20px;
}
.verify-email-page .verify-email-container .terms-text a {
  color: #333;
  text-decoration: underline;
}
.verify-email-page .footer {
  margin-top: 20px;
  font-size: 12px;
  color: #666;
  text-align: center;
}
.verify-email-page .footer p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/authpage/authsubfolders/verifyEmail/verifyEmailForm.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;AACE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AACN;AAEI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAAN;AAIM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAFR;AAIQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AAFV;AAMM;EACE,UAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;AAJR;AAMQ;EACE,yBAAA;AAJV;AAMQ;EACE,yBAAA,EAAA,kCAAA;AAJV;AAOQ;EACE,yBAAA,EAAA,mBAAA;EACA,mBAAA;AALV;AASM;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAPR;AASQ;EACE,yBAAA;AAPV;AAYI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAVN;AAYM;EACE,WAAA;EACA,0BAAA;AAVR;AAeE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAbJ;AAeI;EACE,SAAA;AAbN","sourcesContent":[".verify-email-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n\n  .verify-email-container {\n    width: 450px;\n    text-align: center;\n    padding: 40px;\n    border-radius: 10px;\n\n    h2 {\n      font-size: 20px;\n      margin-bottom: 10px;\n      color: #333;\n    }\n\n    .subtext {\n      font-size: 14px;\n      color: #666;\n      margin-bottom: 30px;\n    }\n\n    .verify-email-form {\n      .code-inputs {\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 20px;\n\n        input {\n          width: 40px;\n          height: 40px;\n          font-size: 18px;\n          text-align: center;\n          border: 1px solid #ddd;\n          border-radius: 60px;\n          background-color: #f9f9f9;\n        }\n      }\n\n      .resend-button {\n        width: 40%;\n        padding: 10px;\n        background-color: #f4eaf4;\n        color: #8e2d8e;\n        border: none;\n        border-radius: 8px;\n        font-size: 14px;\n        cursor: pointer;\n        transition: background-color 0.3s;\n        margin-bottom: 20px;\n\n        &:hover {\n          background-color: #7b2a7b;\n        }\n        &:active {\n          background-color: #7b2a7b; /* Darker shade for active state */\n        }\n\n        &:disabled {\n          background-color: #e0e0e0; /* Disabled color */\n          cursor: not-allowed;\n        }\n      }\n\n      .continue-button {\n        width: 100%;\n        padding: 12px;\n        background-color: #8e2d8e;\n        color: #fff;\n        border: none;\n        border-radius: 5px;\n        font-size: 16px;\n        cursor: pointer;\n        transition: background-color 0.3s;\n\n        &:hover {\n          background-color: #c0c4c9;\n        }\n      }\n    }\n\n    .terms-text {\n      font-size: 12px;\n      color: #666;\n      margin-top: 20px;\n\n      a {\n        color: #333;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .footer {\n    margin-top: 20px;\n    font-size: 12px;\n    color: #666;\n    text-align: center;\n\n    p {\n      margin: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
